export const EQUIPMENT_NAMES_1_ZONE = '1_zone';
export const EQUIPMENT_NAMES_4_ZONE = '4_zone';

export const EQUIPMENT_NAMES = [EQUIPMENT_NAMES_1_ZONE, EQUIPMENT_NAMES_4_ZONE];
